const isError = (value) => value.message !== undefined;
const isString = (value) => typeof value === 'string' || value instanceof String;
const isFunction = (value) => value && {}.toString.call(value) === '[object Function]';

/*
 * Public API Surface of type-checking
 */

/**
 * Generated bundle index. Do not edit.
 */

export { isError, isFunction, isString };

